import { queryOptions } from '@tanstack/react-query';
import { memberships } from '#proto/index.qonto.spend_management.memberships';
import { client, snakeToCamelCaseShallow } from '#queries/utils';
import type { MembershipResponse } from './types';

function getMembershipsMe(organizationId: string) {
  return queryOptions({
    queryKey: [...navigationQueries.membershipsMe(organizationId)] as const,
    async queryFn() {
      const response = await client<MembershipResponse>(`/v2/navigation/memberships/me`, {
        headers: {
          'X-Qonto-Organization-ID': organizationId,
        },
      });

      const camelCasedMembership = snakeToCamelCaseShallow(response.membership);
      return memberships.firstparty.v1.ApiCurrentMembership.fromJSON(camelCasedMembership);
    },
    gcTime: Infinity,
    staleTime: Infinity,
  });
}

function getMembershipsMeAggregate(organizationId: string) {
  return queryOptions({
    queryKey: [...navigationQueries.membershipsMeAggregate(organizationId)] as const,
    async queryFn() {
      const response = await client<MembershipResponse>(`/v3/memberships/me/aggregate`, {
        headers: {
          'X-Qonto-Organization-ID': organizationId,
        },
      });

      return memberships.firstparty.v3.ApiAggregateMembership.fromJSON(response.membership);
    },
    gcTime: Infinity,
    staleTime: Infinity,
  });
}

export const navigationQueries = {
  all: ['navigation'] as const,
  memberships: () => [...navigationQueries.all, 'memberships'] as const,
  membershipsMe: (organizationId: string) =>
    [...navigationQueries.memberships(), 'me', organizationId] as const,
  membershipsMeAggregate: (organizationId: string) =>
    [...navigationQueries.memberships(), 'me', 'aggregate', organizationId] as const,
  getMembershipsMe,
  getMembershipsMeAggregate,
};
